/** "2026-12-16" → "Dec 16, 2026". Month spelled out so a day/month mix-up
 *  can't hide (the CARLA date-convention rule). Parsed as a local date. */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return 'TBD'
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number)
  if (!y || !m || !d) return iso
  return new Date(y, m - 1, d).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export function fmtKg(kg: number): string {
  return `${kg.toLocaleString('en-US', { maximumFractionDigits: 1 })} kg`
}

export function fmtLb(lb: number): string {
  return `${lb.toLocaleString('en-US', { maximumFractionDigits: 2 })} lb`
}

/** Whole days from today to an ISO date (negative = past). */
export function daysUntil(iso: string | null | undefined, today = new Date()): number | null {
  if (!iso) return null
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number)
  const target = new Date(y, m - 1, d)
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate())
  return Math.round((target.getTime() - start.getTime()) / 86_400_000)
}

/** Shipments inside this window with no logged call show as "call due". */
export const CALL_WINDOW_DAYS = 14
